import FormDocument, { FormDocumentStatus } from './form-document';
import { SyncStatus } from 'src/app/entities/SyncStatus';

type FormDocumentMetadataType = Pick<FormDocument, 'RecordId' | 'DocumentId' | 'CreatedDate' | 'ModifiedDate' | 'Status' | 'syncStatus'>;
export class FormDocumentMetadata implements FormDocumentMetadataType {
  RecordId: number;
  DocumentId: string;
  CreatedDate: string;
  ModifiedDate: string;
  Status: FormDocumentStatus;
  syncStatus: SyncStatus;
  constructor(record: FormDocument) {
    this.RecordId = record.RecordId;
    this.DocumentId = record.DocumentId;
    this.CreatedDate = record.CreatedDate;
    this.ModifiedDate = record.ModifiedDate;
    this.Status = record.Status;
    this.syncStatus = record.syncStatus;
  }
}
